import { defineStore } from 'pinia'
import userApi from '@/services/user/api'
import {
  clearAuth,
  getAuthUser,
  getAuthUserId,
  setAuthSession,
  setAuthUser
} from '@/services/auth'

const normalizeUserId = (user = {}) =>
  user?.s_id ||
  user?.id ||
  user?.user_id ||
  user?.vendor_id ||
  user?.vendorId ||
  ''

export const useSessionStore = defineStore('session', {
  state: () => ({
    user: getAuthUser() || null,
    profile: getAuthUser() || null,
    userId: getAuthUserId() || '',
    email: (getAuthUser() || {}).email || (getAuthUser() || {}).s_email || '',
    phone: (getAuthUser() || {}).phone || (getAuthUser() || {}).s_phone || ''
  }),
  actions: {
    setUser(user) {
      if (!user) return
      const merged = {
        ...(this.user || {}),
        ...user,
        s_id: normalizeUserId(user) || normalizeUserId(this.user || {})
      }
      this.user = merged
      this.userId = normalizeUserId(merged)
      this.email = merged.email || merged.s_email || this.email || ''
      this.phone = merged.phone || merged.s_phone || this.phone || ''
      setAuthUser({ ...merged, role: 'user' })
      setAuthSession({ loggedIn: true, role: 'user', s_id: this.userId })
    },
    async loadUser() {
      const user = getAuthUser() || null
      this.user = user
      this.profile = this.profile || user
      this.userId = getAuthUserId() || normalizeUserId(user || {})
      this.email = user?.email || user?.s_email || ''
      this.phone = user?.phone || user?.s_phone || ''
      return user
    },
    async fetchProfile(force = false) {
      if (!this.userId) {
        await this.loadUser()
      }
      if (!this.userId) return null
      if (!force && this.profile) return this.profile
      try {
        const formData = new FormData()
        formData.append('id', this.userId)
        formData.append('s_id', this.userId)
        formData.append('user_id', this.userId)
        const { data } = await userApi.getProfile(formData)
        const profile = data?.user || data?.data?.user || data?.data?.[0] || data?.data || data?.profile || null
        if (profile) {
          this.profile = profile
          this.setUser(profile)
        }
        return profile
      } catch {
        return this.profile || this.user || null
      }
    },
    updateProfileLocally(patch = {}) {
      this.profile = { ...(this.profile || {}), ...patch }
      this.user = { ...(this.user || {}), ...patch }
      this.email = this.profile?.email || this.profile?.s_email || this.email || ''
      this.phone = this.profile?.phone || this.profile?.s_phone || this.phone || ''
      setAuthUser({ ...(this.user || {}), ...(this.profile || {}), role: 'user' })
    },
    logout() {
      this.user = null
      this.profile = null
      this.userId = ''
      this.email = ''
      this.phone = ''
      clearAuth()
    }
  }
})
